// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane.roles-pane {
  text-align: left;
}
.pane.roles-pane .roles-options {
  margin: 0 1rem -0.5rem 0;
  padding: 0 1rem;
}
.pane.roles-pane .roles-options .label-text {
  margin: 0 0 0 0.5rem;
  width: unset;
}
.pane.roles-pane .roles-list {
  display: grid;
  grid-template-columns: auto 23.5rem;
  padding: 0;
}
.pane.roles-pane .role-card {
  border-top: var(--border-width) solid transparent;
  border-bottom: var(--border-elevated);
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;
  margin-top: calc(-1 * var(--border-width));
  padding: 0.8rem 1rem 1.1rem 1rem;
  text-align: right;
}
.pane.roles-pane .role-card:first-child {
  border-top-color: var(--color-elevated-border);
  margin-top: 1rem;
}
.pane.roles-pane .role-card.archived .role-card-inputs, .pane.roles-pane .role-card.archived .role-registration-send-button, .pane.roles-pane .role-card.archived .role-card-aqumen-id {
  opacity: 0.3;
}
.pane.roles-pane .role-card.confirming-archive .role-card-inputs input.role-description, .pane.roles-pane .role-card.confirming-archive .role-card-inputs input.role-identifier {
  color: var(--color-elevated-warn);
}
.pane.roles-pane .role-card.confirming-archive .role-card-meta .role-card-ids .data-label, .pane.roles-pane .role-card.confirming-archive .role-card-meta .role-card-ids .display-id {
  color: var(--color-elevated-warn) !important;
  opacity: 1;
}
.pane.roles-pane .role-card.new {
  border-top: var(--border-elevated);
  font-size: 0.9rem;
  margin-top: 1.5rem;
}
.pane.roles-pane .role-card.new.confirming {
  border-color: var(--color-elevated-warn);
}
.pane.roles-pane .role-card.new.confirming button.role-create-and-send {
  color: var(--color-elevated-warn);
  font-weight: bold;
}
.pane.roles-pane .role-card.new:has(:focus-within) .role-card-inputs .label-text, .pane.roles-pane .role-card.new.confirming .role-card-inputs .label-text {
  opacity: 1;
}
.pane.roles-pane .role-card.new .role-card-inputs input.role-description, .pane.roles-pane .role-card.new .role-card-inputs input.role-identifier {
  margin-left: 1rem;
  width: calc(100% - 7.2rem);
}
.pane.roles-pane .role-card.new .role-card-inputs .label-text {
  display: inline-block;
  width: unset;
}
.pane.roles-pane .role-card.new button.role-create-and-send {
  width: 18rem;
}
.pane.roles-pane .role-card.new .role-card-meta .role-card-actions {
  margin-top: 0;
}
.pane.roles-pane .role-card.new .role-card-action:not(:first-child) {
  margin-top: 1rem;
}
.pane.roles-pane .role-card .role-card-inputs {
  grid-column: 1;
  margin-left: -0.2rem;
  min-width: 20rem;
}
.pane.roles-pane .role-card .role-card-inputs label.role-description, .pane.roles-pane .role-card .role-card-inputs label.role-identifier {
  display: block;
}
.pane.roles-pane .role-card .role-card-inputs .label-text {
  display: none;
}
.pane.roles-pane .role-card .role-card-inputs input.role-description, .pane.roles-pane .role-card .role-card-inputs input.role-identifier {
  background-color: var(--color-elevated-canvas);
  width: calc(100% - 1.5rem);
  margin-top: 0.5rem;
  margin-left: 0;
}
.pane.roles-pane .role-card .role-card-inputs input.role-description:focus, .pane.roles-pane .role-card .role-card-inputs input.role-identifier:focus {
  background-color: var(--color-elevated-input);
}
.pane.roles-pane .role-card .role-card-inputs input.role-description {
  margin-top: 1rem;
}
.pane.roles-pane .role-card .role-card-inputs input.role-description:focus {
  opacity: 1;
}
.pane.roles-pane .role-card .role-card-inputs input.role-identifier {
  font-size: 1.1rem;
}
.pane.roles-pane .role-card .role-card-meta {
  padding-top: 0.5rem;
  grid-column: 2;
}
.pane.roles-pane .role-card .role-card-meta .role-card-ids {
  height: 2.25rem;
}
.pane.roles-pane .role-card .role-card-meta .role-card-actions {
  margin-top: 1rem;
  text-align: right;
}
.pane.roles-pane .role-card .role-card-meta .role-card-actions .confirming .role-archive-button, .pane.roles-pane .role-card .role-card-meta .role-card-actions .confirming .role-unarchive-button {
  color: var(--color-elevated-warn);
}
.pane.roles-pane .role-card .role-card-meta .role-card-actions .role-archive-button, .pane.roles-pane .role-card .role-card-meta .role-card-actions .role-unarchive-button {
  margin-left: 1rem;
  width: 7rem;
}
.pane.roles-pane .role-card .role-card-meta .role-card-actions .role-archive, .pane.roles-pane .role-card .role-card-meta .role-card-actions .role-registration-send {
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/style/panes/access_control/access_control_roles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,wBAAA;EACA,eAAA;AACJ;AACI;EACE,oBAAA;EACA,YAAA;AACN;AAGE;EACE,aAAA;EACA,mCAAA;EACA,UAAA;AADJ;AAIE;EACE,iDAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0CAAA;EACA,gCAAA;EACA,iBAAA;AAFJ;AAII;EACE,8CAAA;EACA,gBAAA;AAFN;AAMM;EACE,YAAA;AAJR;AAWQ;EAEE,iCAAA;AAVV;AAcQ;EACE,4CAAA;EACA,UAAA;AAZV;AAiBI;EACE,kCAAA;EACA,iBAAA;EACA,kBAAA;AAfN;AAiBM;EACE,wCAAA;AAfR;AAiBQ;EACE,iCAAA;EACA,iBAAA;AAfV;AAoBQ;EACE,UAAA;AAlBV;AAuBQ;EACE,iBAAA;EACA,0BAAA;AArBV;AAwBQ;EACE,qBAAA;EACA,YAAA;AAtBV;AA0BM;EACE,YAAA;AAxBR;AA2BM;EACE,aAAA;AAzBR;AA4BM;EACE,gBAAA;AA1BR;AA8BI;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;AA5BN;AA8BM;EACE,cAAA;AA5BR;AA+BM;EACE,aAAA;AA7BR;AAgCM;EACE,8CAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;AA9BR;AA+BQ;EACE,6CAAA;AA7BV;AAiCM;EACE,gBAAA;AA/BR;AAgCQ;EACE,UAAA;AA9BV;AAkCM;EACE,iBAAA;AAhCR;AAoCI;EACE,mBAAA;EACA,cAAA;AAlCN;AAoCM;EACE,eAAA;AAlCR;AAqCM;EACE,gBAAA;EACA,iBAAA;AAnCR;AAsCU;EACE,iCAAA;AApCZ;AAwCQ;EACE,iBAAA;EACA,WAAA;AAtCV;AAyCQ;EACE,qBAAA;AAvCV","sourcesContent":[".pane.roles-pane {\n  text-align: left;\n\n  .roles-options {\n    margin: 0 1rem -0.5rem 0;\n    padding: 0 1rem;\n\n    .label-text {\n      margin: 0 0 0 0.5rem;\n      width: unset;\n    }\n  }\n\n  .roles-list {\n    display: grid;\n    grid-template-columns: auto 23.5rem;\n    padding: 0;\n  }\n\n  .role-card {\n    border-top: var(--border-width) solid transparent;\n    border-bottom: var(--border-elevated);\n    display: grid;\n    grid-column: span 2;\n    grid-template-columns: subgrid;\n    margin-top: calc(-1 * var(--border-width));\n    padding: 0.8rem 1rem 1.1rem 1rem;\n    text-align: right;\n\n    &:first-child {\n      border-top-color: var(--color-elevated-border);\n      margin-top: 1rem;\n    }\n\n    &.archived {\n      .role-card-inputs, .role-registration-send-button, .role-card-aqumen-id {\n        opacity: 0.3;\n      }\n    }\n\n    &.confirming-archive {\n      // border-color: var(--color-elevated-warn) !important;\n      .role-card-inputs {\n        input.role-description, input.role-identifier {\n          // border-color: var(--color-elevated-warn);\n          color: var(--color-elevated-warn);\n        }\n      }\n      .role-card-meta .role-card-ids {\n        .data-label, .display-id {\n          color: var(--color-elevated-warn) !important;\n          opacity: 1;\n        }\n      }\n    }\n\n    &.new {\n      border-top: var(--border-elevated);\n      font-size: 0.9rem;\n      margin-top: 1.5rem;\n\n      &.confirming {\n        border-color: var(--color-elevated-warn);\n\n        button.role-create-and-send {\n          color: var(--color-elevated-warn);\n          font-weight: bold;\n        }\n      }\n\n      &:has(:focus-within), &.confirming {\n        .role-card-inputs .label-text {\n          opacity: 1.0;\n        }\n      }\n\n      .role-card-inputs {\n        input.role-description, input.role-identifier {\n          margin-left: 1rem;\n          width: calc(100% - 7.2rem);\n        }\n\n        .label-text {\n          display: inline-block;\n          width: unset;\n        }\n      }\n\n      button.role-create-and-send {\n        width: 18rem;\n      }\n\n      .role-card-meta .role-card-actions {\n        margin-top: 0;\n      }\n\n      .role-card-action:not(:first-child) {\n        margin-top: 1rem;\n      }\n    }\n\n    .role-card-inputs {\n      grid-column: 1;\n      margin-left: -0.2rem;\n      min-width: 20rem;\n\n      label.role-description, label.role-identifier {\n        display: block;\n      }\n\n      .label-text {\n        display: none;\n      }\n\n      input.role-description, input.role-identifier {\n        background-color: var(--color-elevated-canvas);\n        width: calc(100% - 1.5rem);\n        margin-top: 0.5rem;\n        margin-left: 0;\n        &:focus {\n          background-color: var(--color-elevated-input);\n        }\n      }\n\n      input.role-description {\n        margin-top: 1rem;\n        &:focus {\n          opacity: 1.0;\n        }\n      }\n\n      input.role-identifier {\n        font-size: 1.1rem;\n      }\n    }\n\n    .role-card-meta {\n      padding-top: 0.5rem;\n      grid-column: 2;\n\n      .role-card-ids {\n        height: 2.25rem;\n      }\n\n      .role-card-actions {\n        margin-top: 1rem;\n        text-align: right;\n\n        .confirming {\n          .role-archive-button, .role-unarchive-button {\n            color: var(--color-elevated-warn);\n          }\n        }\n\n        .role-archive-button, .role-unarchive-button {\n          margin-left: 1rem;\n          width: 7rem;\n        }\n\n        .role-archive, .role-registration-send {\n          display: inline-block;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
